import { Option } from '@storeblocks/select';

export interface OwnContributionOption extends Option {
  id: string;
  value: OwnContributionValue;
  label: (typeof OwnContributionLabel)[OwnContributionValue];
}

export enum OwnContributionCode {
  ONE_DEPRECATED = '1',
  FIVE_DEPRECATED = '5',
  TWO_DEPRECATED = '2',
  THREE_DEPRECATED = '3',
  FOUR_DEPRECATED = '4',
  SIX_DEPRECATED = '6',

  ELEVEN = '11',
  TWELVE = '12',
  THIRTEEN = '13',
  FIFTEEN = '15',
  SEVENTEEN = '17',
  NINETEEN = '19',
}

export enum OwnContributionValue {
  FOUR_THOUSAND = '4000',
  SIX_THOUSAND = '6000',
  EIGHT_THOUSAND = '8000',
  TEN_THOUSAND = '10000',
  TWELVE_THOUSAND = '12000',
  FOURTEEN_THOUSAND = '14000',
  SIXTEEN_THOUSAND = '16000',
  EIGHTEEN_THOUSAND = '18000',
  THIRTY_THOUSAND = '30000',
  THIRTY_TWO_THOUSAND = '32000',
}

export const OwnContributionLabel = {
  [OwnContributionValue.FOUR_THOUSAND]: '4 000 kr',
  [OwnContributionValue.SIX_THOUSAND]: '6 000 kr',
  [OwnContributionValue.EIGHT_THOUSAND]: '8 000 kr',
  [OwnContributionValue.TEN_THOUSAND]: '10 000 kr',
  [OwnContributionValue.TWELVE_THOUSAND]: '12 000 kr',
  [OwnContributionValue.FOURTEEN_THOUSAND]: '14 000 kr',
  [OwnContributionValue.SIXTEEN_THOUSAND]: '16 000 kr',
  [OwnContributionValue.EIGHTEEN_THOUSAND]: '18 000 kr',
  [OwnContributionValue.THIRTY_THOUSAND]: '30 000 kr',
  [OwnContributionValue.THIRTY_TWO_THOUSAND]: '32 000 kr',
} as const;

export enum ChangeDateCategory {
  IMMEDIATELY_OR_THIRTY_DAYS_RENEWAL = 1,
  THIRTY_DAYS_RENEWAL = 2,
}
